var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"category-list md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4"},_vm._l((_vm.categoryList),function(category){return _c('CategoryCard',{key:category.identifier,attrs:{"category":category,"language":_vm.language}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }